import { Content } from 'pdfmake/interfaces';
import { DynamicTemplateConfig } from '../../models/dynamic-template-config.interface';

/**
 * Custom invoice name from the template config. Returns '' unless
 * layoutSettings.isinvoicename is true and invoicename is a non-empty string.
 */
export function getInvoiceName(config?: DynamicTemplateConfig | null): string {
  const ls = config?.layoutSettings;
  if (ls?.isinvoicename !== true || typeof ls.invoicename !== 'string') return '';
  return ls.invoicename.trim();
}

/** Small centered title printed at the top of A4 / A5 invoices. */
export function buildInvoiceNameTitle(config: DynamicTemplateConfig | null | undefined, font?: string): Content | null {
  const name = getInvoiceName(config);
  if (!name) return null;
  return {
    text: name,
    ...(font ? { font } : {}),
    fontSize: invoiceNameFontSize(config),
    alignment: 'center',
    color: config?.themeSettings?.textColor || '#000000',
    margin: [0, 0, 0, 0],
  };
}

/** Vertical space the title takes, for the page-fit height estimates. */
export function invoiceNameTitleHeight(config?: DynamicTemplateConfig | null): number {
  return getInvoiceName(config) ? Math.ceil(invoiceNameFontSize(config) * 1.2) : 0;
}

function invoiceNameFontSize(config?: DynamicTemplateConfig | null): number {
  return config?.themeSettings?.baseFontSize || 8;
}
